var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthLogoKurzNeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ETH",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "186.066px",
    height: "68.032px",
    viewBox: "0 0 186.066 68.032",
    enableBackground: "new 0 0 186.066 68.032",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.18,39.305c-0.81,4.017-3.913,4.221-4.528,4.221c-1.752,0-2.797-1.012-2.797-2.705 c0-0.386,0.057-0.912,0.155-1.439l1.919-9.562l0.008-0.037h-2.267l-1.956,9.805l-0.026,0.14c-0.084,0.443-0.163,0.863-0.163,1.408 c0,2.634,1.73,4.402,4.309,4.402c1.886,0,3.401-0.619,4.507-1.841l-0.294,1.615l-0.007,0.038h2.235l3.088-15.53l0.006-0.037 h-2.299L109.18,39.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.635,29.595c-1.752,0-3.304,0.716-4.281,1.974l0.351-1.748l0.007-0.037h-2.235l-3.089,15.529 l-0.007,0.038h2.269l1.891-9.524c0.483-2.445,2.36-4.218,4.465-4.218c0.904,0,1.616,0.356,2.176,1.087l0.021,0.028l1.841-1.649 l-0.019-0.023C127.174,30.07,126.064,29.595,124.635,29.595z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "87.149,31.759 87.143,31.797 94.878,31.797 84.579,43.442 84.574,43.448 84.186,45.351  95.164,45.351 95.554,43.337 87.348,43.337 97.679,31.692 97.684,31.685 98.071,29.784 87.534,29.784  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "128.332,45.313 128.324,45.351 130.591,45.351 133.684,29.784 131.455,29.784  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M159.072,29.596c-1.865,0-3.321,0.571-4.44,1.75l1.759-8.668h-2.268l-4.555,22.676h2.268l1.891-9.525 c0.811-4.015,3.941-4.218,4.56-4.218c1.733,0,2.769,1.011,2.769,2.704c0,0.384-0.059,0.908-0.158,1.44l-1.924,9.6h2.266 l1.988-9.809c0.096-0.521,0.159-0.962,0.159-1.547C163.385,31.365,161.649,29.596,159.072,29.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M144.041,29.595c-4.113,0-7,2.897-7.923,7.949c-0.166,0.846-0.224,1.792-0.224,2.397 c0,3.452,2.096,5.597,5.472,5.597c1.963,0,3.755-0.752,5.181-2.177l0.021-0.021l-1.308-1.595l-0.023-0.028l-0.024,0.027 c-1.203,1.266-2.281,1.783-3.721,1.783c-1.609,0-3.33-0.958-3.33-3.648c0-0.842,0.1-1.538,0.249-2.322 c0.243-1.32,0.79-3.164,2.005-4.447c0.966-0.996,2.111-1.5,3.406-1.5c1.352,0,2.197,0.481,3.021,1.715l0.02,0.031l1.664-1.406 l0.023-0.02l-0.018-0.025C147.396,30.306,146.01,29.595,144.041,29.595z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "132.296,25.512 134.568,25.512 135.133,22.677 132.869,22.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "110.249,25.512 112.522,25.512 113.084,22.677 110.823,22.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "104.203,25.512 106.475,25.512 107.039,22.677 104.777,22.677  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "73.91,31.464 68.809,31.464 70.6,22.677 27.235,22.677 22.681,45.353 39.971,45.353  41.104,39.685 30.895,39.685 31.514,36.567 41.719,36.567 42.747,31.464 32.539,31.464 33.157,28.345 49.337,28.345  45.921,45.353 53.008,45.353 56.424,28.345 62.374,28.345 58.958,45.353 66.046,45.353 67.795,36.567 72.896,36.567  71.146,45.353 78.233,45.353 82.789,22.677 75.702,22.677  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthLogoKurzNeg);
export default __webpack_public_path__ + "static/media/eth_logo_kurz_neg.2fa074632282773a72d39eceaec5af36.svg";
export { ForwardRef as ReactComponent };